import { SessionStatus } from 'globals/enums';

export const isSessionEnded = (session_status) => {
  return (
    session_status === SessionStatus.NoShow ||
    session_status === SessionStatus.Completed ||
    session_status === SessionStatus.Terminated
  );
};
